import { render } from "./CartSummary.vue?vue&type=template&id=00f3dff2"
const script = {}
script.render = render

export default script